import React, { useState } from 'react';
import './Header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faXTwitter, faYoutube, faTiktok, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import logo from '../../photos/brand/integra-new-logo.svg';
import { Link, NavLink } from 'react-router-dom';
import siteMeta from '../../config/siteMeta';

const navigationLinks = [
  { to: '/', label: 'Home', end: true },
  { to: '/about', label: 'About Us' },
  { to: '/projects', label: 'Projects' },
  { to: '/sponsors', label: 'Sponsors' },
  { to: '/integrai', label: 'IntegrAI' },
  { to: '/awards', label: 'Awards' },
];

const socialIcons = {
  Instagram: faInstagram,
  X: faXTwitter,
  YouTube: faYoutube,
  TikTok: faTiktok,
  LinkedIn: faLinkedin,
};

const socialLinks = siteMeta.SOCIAL_LINKS.map((link) => ({
  ...link,
  icon: socialIcons[link.platform],
}));

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header
      className={`header ${menuOpen ? 'is-open' : ''}`}
      role="banner"
      itemScope
      itemType="https://schema.org/WPHeader"
    >
      <div className="header-brand">
        <Link to="/" className="brand-link" aria-label="Return to INTEGRA 3646 homepage" onClick={closeMenu}>
          <img
            src={logo}
            alt="INTEGRA 3646 team logo"
            className="brand-logo"
            itemProp="logo"
            width="64"
            height="64"
          />
        </Link>
      </div>

      <button
        className="header-menu-toggle"
        type="button"
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
        aria-controls="primary-navigation"
        onClick={() => setMenuOpen((isOpen) => !isOpen)}
      >
        <span />
        <span />
        <span />
      </button>

      <div className="header-nav-shell" id="primary-navigation">
        <nav
          className="header-navigation"
          role="navigation"
          aria-label="Main navigation"
          itemScope
          itemType="https://schema.org/SiteNavigationElement"
        >
          <ul className="nav-links">
            {navigationLinks.map(({ to, label, end = false }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  end={end}
                  className={({ isActive }) => `header-button${isActive ? ' active' : ''}`}
                  itemProp="url"
                  onClick={closeMenu}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <nav
          className="social-medias"
          role="navigation"
          aria-label="Social media links"
          itemScope
          itemType="https://schema.org/Organization"
        >
          <ul className="social-links">
            {socialLinks.map(({ href, label, icon }) => (
              <li key={label}>
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  itemProp="sameAs"
                >
                  <FontAwesomeIcon icon={icon} />
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
